import { render, staticRenderFns } from "./split-view-grid.vue?vue&type=template&id=a5cf88b2"
import script from "./split-view-grid.vue?vue&type=script&lang=js"
export * from "./split-view-grid.vue?vue&type=script&lang=js"
import style0 from "./split-view-grid.vue?vue&type=style&index=0&id=a5cf88b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports